export default class StickyBlock {
    constructor(block = '.js-sticky-block', wrapper = '.js-sticky-wrapper', breakpoint = 992) {
        this.priceSticky = $('.price-sticky');
        this.header = $('.header');
        this.wrapper = $(wrapper);
        this.block = $(wrapper).find(block);
        this.breakpoint = breakpoint;

        this.wrapperPosition = {};
        this.blockPosition = {};
        this.marginTop = 0;
        this.scrollEnd = 0;

        this.onScrollEvent = this.updateOnScroll.bind(this);
    }

    setDefaults() {
        this.priceHeight =  this.priceSticky.length > 0? this.priceSticky.outerHeight() : 0;
        this.marginTop = this.header.outerHeight() + this.priceHeight;

        this.blockPosition.top = this.block.offset().top;
        this.blockPosition.left = this.block.offset().left;
        this.blockPosition.width = this.block.outerWidth();
        this.blockPosition.height = this.block.outerHeight();

        this.wrapperPosition.width = this.wrapper.outerWidth();
        this.wrapperPosition.height = this.wrapper.outerHeight();

        this.scrollEnd = this.wrapper.offset().top + this.wrapperPosition.height - (this.blockPosition.height + this.marginTop);

        this.wrapper.css({
            'height': `${this.wrapperPosition.height}px`,
            'position': 'relative',
            'width': `${this.wrapperPosition.width}px`,
            'flex-shrink': '0'
        })

        this.block.css({
            'width': `${this.blockPosition.width}px`
        });
    }

    updateOnScroll() {
        const top = $(window).scrollTop();
        if (top > (this.blockPosition.top - this.marginTop)) {
            if (top < this.scrollEnd) {
                this.block.css({
                    'position': 'fixed',
                    'top': `${this.marginTop}px`,
                    'left': `${this.blockPosition.left}px`,
                    'bottom': 'auto',
                });
            } else {
                this.block.css({
                    'position': 'absolute',
                    'top': 'auto',
                    'bottom': '0',
                    'left': '0',
                });
            }

        } else {
            this.block.css({
                'position': 'relative',
                'top': 'auto',
                'left': 'auto',
                'bottom': 'auto',
            });
        }
    }

    destroy() {
        this.wrapper.attr('style', '');
        this.block.attr('style', '');
    }

    init() {
        if (this.wrapper.length > 0 && this.block.length > 0) {

            if ($(window).width() > this.breakpoint) {
                this.setDefaults();

                window.addEventListener('scroll', this.onScrollEvent);
                window.scrollTo(window.pageXOffset, window.pageYOffset + 1);
            }

            $(window).on('resize', () => {
                this.destroy();
                window.removeEventListener('scroll', this.onScrollEvent);

                if ($(window).width() > this.breakpoint) {
                    this.setDefaults();
                    window.addEventListener('scroll', this.onScrollEvent);
                    window.scrollTo(window.pageXOffset, window.pageYOffset + 1);
                }
            })
        }
    }
}